import { openBlock as o, createElementBlock as n, createElementVNode as t } from "vue";
import { _ as l } from "./_plugin-vue_export-helper-dad06003.js";
const r = {}, c = {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function i(s, e) {
  return o(), n("svg", c, e[0] || (e[0] = [
    t("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.5514 0.525788C5.27171 -0.222283 6.53242 -0.165127 7.34969 0.652651C8.16639 1.46992 8.22319 2.72972 7.47576 3.44975L4.35852 6.45267C4.28861 6.52005 4.17327 6.49953 4.12804 6.41364C3.55486 5.32522 2.66568 4.43776 1.59473 3.86629C1.50939 3.82076 1.48929 3.7059 1.55639 3.63623L4.5514 0.525788ZM0.973749 4.37411C0.919698 4.34999 0.85651 4.36307 0.815461 4.4057L0.788225 4.43399L0.784493 4.43795C0.757079 4.46742 0.737009 4.5037 0.726271 4.54441L0.0184216 7.22811C-0.0954793 7.65991 0.338782 8.09498 0.770806 7.98183L3.45451 7.27908C3.49985 7.26719 3.53971 7.24376 3.57084 7.21148L3.5945 7.18867C3.63705 7.1477 3.65014 7.08467 3.62618 7.03066C3.0995 5.84388 2.14738 4.89762 0.973749 4.37411Z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const f = /* @__PURE__ */ l(r, [["render", i]]);
export {
  f as P
};
